import { AlphaFiSDK } from 'alphafi-sdk-js';
import { API_BASE_URL } from './config';
import { getSuiGraphqlUrl, getSuiGrpcUrl, getSuiGrpcToken } from './rpcEndpoints';
import { NETWORKS } from '../types/commonTypes';
// Cache SDK instances per network to preserve internal caching
const sdkInstanceCache = new Map();
/**
 * Validates and normalizes network string to supported network types
 * @param network - Network string to validate
 * @returns Validated network string, defaults to 'mainnet' if invalid
 */
export function validateNetwork(network) {
    return NETWORKS.includes(network) ? network : NETWORKS[0];
}
/**
 * Gets or creates an AlphaFiSDK instance with validated network configuration.
 * SDK instances are cached per network to preserve internal caching mechanisms.
 * @param network - Network string to validate
 * @param address - User wallet address (unused, kept for API compatibility)
 * @returns Configured AlphaFiSDK instance
 */
export function createAlphaFiSDK(network) {
    const validatedNetwork = validateNetwork(network);
    // Return cached instance if available
    const cached = sdkInstanceCache.get(validatedNetwork);
    if (cached) {
        return cached;
    }
    // Create new instance and cache it
    const sdk = new AlphaFiSDK({
        network: validatedNetwork,
        apiBaseUrl: API_BASE_URL,
        graphqlUrl: getSuiGraphqlUrl(validatedNetwork),
        grpcUrl: getSuiGrpcUrl(validatedNetwork),
        grpcToken: getSuiGrpcToken(validatedNetwork) || undefined,
    });
    sdkInstanceCache.set(validatedNetwork, sdk);
    return sdk;
}
/**
 * Clears the SDK instance cache. Useful for testing or when network configuration changes.
 */
export function clearAlphaFiSDKCache() {
    sdkInstanceCache.clear();
}
